// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled[data-v-1f115702] {\n  cursor: not-allowed;\n  color: #808080;\n}\n.box[data-v-1f115702] {\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n  padding: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
